import { Branch, Group, Node, User } from '@xanadu/model';
import { UserMenu } from './user-menu';
import { MenuBuilder } from './menu-builder';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UserMenuBuilder extends MenuBuilder {

    public Build(node: Node, clipboard: Node): UserMenu {
        const menu = new UserMenu();
        let isSystemUser = false;

        if (node instanceof Group) {
            this.forGroup(menu, node);
        } else if (node instanceof User) {
            const user = node as User;
            isSystemUser = user._system;

            this.forUser(menu, node)
        }

        this.forEdit(menu, node, clipboard, isSystemUser);

        return menu;
    }

    private forGroup(menu: UserMenu, node: Node): void {
        if (node.isNew) {
            return;
        }

        menu.group = true;
        menu.user = true;
    }

    private forUser(menu: UserMenu, node: Node): void {
    }

    private forEdit(menu: UserMenu, node: Node, clipboard: Node, isSystemUser: boolean): void {
        menu.delete = !isSystemUser && !!node.parentId && (!(node instanceof Branch) || !node.nodes?.length && !node.branches?.length);
        menu.cut = !isSystemUser && !!node.parentId;
        menu.copy = !isSystemUser && !!node.parentId && !(node instanceof Group);
        menu.paste = clipboard && !clipboard.childOf(node) && clipboard.fit(node as Branch) && !node.isNew;
    }
}
